// extracted by mini-css-extract-plugin
export default {"arrow":"Arrows_arrow__FejVI"};